import type { IsoDate, Month } from './dates.js';

/** Tipo de categoría: cuenta como gasto, como ingreso, o no cuenta (traspasos, "Dividido"…). */
export type CategoryKind = 'expense' | 'income' | 'excluded';

export interface Category {
  name: string;
  kind: CategoryKind;
  nature: 'fixed' | 'variable' | '';
  keywords: string[];
  /** Si llega a partir de este día del mes, cuenta en el mes siguiente (p. ej. la nómina del 23); null o sin poner: en su mes. */
  nextMonthFrom?: number | null;
}

export interface Account {
  name: string;
  bank: string;
  type: string;
  /** Parte que es tuya (0–1); p. ej. 0,5 en una cuenta conjunta. */
  share: number;
  inNetWorth: boolean;
  opening: number;
  openingDate: IsoDate | '';
  bankBalance: number | null;
  bankBalanceDate: IsoDate | '';
}

/** Una fila de Movimientos (columnas que rellena el usuario + Id). */
export interface Movement {
  id: string;
  date: IsoDate;
  concept: string;
  amount: number;
  account: string;
  category: string;
  shared: boolean;
  group: string;
  note: string;
  /** "Mes (opcional)": cuenta en este mes en lugar del de la fecha. '' si no hay. */
  month: Month | '';
}

/** Una parte de un movimiento dividido (pestaña Divisiones). */
export interface Part {
  movementId: string;
  category: string;
  amount: number;
  note: string;
}

/** Una fila de Presupuesto: importe mensual y, opcionalmente, un importe distinto para meses concretos. */
export interface BudgetRow {
  year: number;
  category: string;
  monthly: number;
  /** Índice 0 = enero. null = usa "monthly". */
  overrides: Array<number | null>;
  warn: boolean;
  note: string;
}

export const NO_CATEGORY = 'Sin categoría';
export const DIVIDED = 'Dividido';

/** Fila especial de Presupuesto: lo que quieres ahorrar (se planifica como un gasto más: "págate primero"). */
export const SAVINGS_GOAL = 'Objetivo de ahorro';
